/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} To_Xml_Deep_P3Inputs */

const en_to_xml_deep_p3 = /** @type {(inputs: To_Xml_Deep_P3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The second invalid case is a top level array. XML permits exactly one root element, so mapping an array of two records straight through would produce two sibling roots and an unparseable document. A top level array is therefore wrapped in a single root element with each entry written as an item element. Arrays nested under a key keep the repeated sibling convention, because there the parent element already provides the required single container.`)
};

const ko_to_xml_deep_p3 = /** @type {(inputs: To_Xml_Deep_P3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`두 번째로 유효하지 않은 경우는 최상위 배열입니다. XML은 루트 요소를 정확히 하나만 허용하므로, 레코드 두 개짜리 배열을 그대로 대응시키면 형제 루트가 두 개인 파싱 불가 문서가 됩니다. 그래서 최상위 배열은 하나의 루트 요소로 감싸이고 각 항목은 item 요소로 작성됩니다. 키 아래에 중첩된 배열은 반복 형제 관례를 유지합니다. 그곳에서는 부모 요소가 이미 필요한 단일 컨테이너를 제공하기 때문입니다.`)
};

const ja_to_xml_deep_p3 = /** @type {(inputs: To_Xml_Deep_P3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2 つ目の妥当でないケースは最上位の配列です。XML はルート要素をちょうど 1 つだけ許すので、2 件のレコードの配列をそのまま対応させると兄弟のルートが 2 つあるパース不能な文書になります。そのため最上位の配列は 1 つのルート要素で包まれ、各項目は item 要素として書かれます。キーの下にネストした配列は繰り返し兄弟の慣習を保ちます。そこでは親要素が必要な単一のコンテナをすでに提供しているからです。`)
};

/**
* | output |
* | --- |
* | "The second invalid case is a top level array. XML permits exactly one root element, so mapping an array of two records straight through would produce two sib..." |
*
* @param {To_Xml_Deep_P3Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const to_xml_deep_p3 = /** @type {((inputs?: To_Xml_Deep_P3Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<To_Xml_Deep_P3Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_to_xml_deep_p3(inputs)
	if (locale === "ko") return ko_to_xml_deep_p3(inputs)
	return ja_to_xml_deep_p3(inputs)
});